import FacilitiesSection1 from './FacilitiesSection1';

export default FacilitiesSection1;